var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDocumentsInReview = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 29.3332C19.4533 29.3332 19 28.8798 19 28.3332V3.6665C19 3.11984 19.4533 2.6665 20 2.6665C20.5467 2.6665 21 3.11984 21 3.6665V28.3332C21 28.8798 20.5467 29.3332 20 29.3332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24 26.6668H20V5.3335H24C26.9467 5.3335 29.3333 7.72016 29.3333 10.6668V21.3335C29.3333 24.2802 26.9467 26.6668 24 26.6668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.00033 5.3335C5.05366 5.3335 2.66699 7.72016 2.66699 10.6668V21.3335C2.66699 24.2802 5.05366 26.6668 8.00033 26.6668H14.667C15.4003 26.6668 16.0003 26.0668 16.0003 25.3335V6.66683C16.0003 5.9335 15.4003 5.3335 14.667 5.3335H8.00033ZM10.3337 20.6668C10.3337 21.2135 9.88033 21.6668 9.33366 21.6668C8.78699 21.6668 8.33366 21.2135 8.33366 20.6668V11.3335C8.33366 10.7868 8.78699 10.3335 9.33366 10.3335C9.88033 10.3335 10.3337 10.7868 10.3337 11.3335V20.6668Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDocumentsInReview, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/documents-in-review.f67b8e70.svg";
export { ForwardRef as ReactComponent };